import { useState } from 'react';
import DOMPurify from 'dompurify';

// --- Reusable ReadMore Component ---
const ReadMore = ({ content, limit = 150 }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    // Agar content null/undefined ho to crash se bachaye
    if (!content) return null;

    // 1. Helper Function: HTML tags hata kar sirf text count karne ke liye
    // Ye zaroori hai taake hum "<h1>" ke characters ko count na karein, sirf asli text ko karein.
    const getPlainText = (htmlString) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlString;
        return tempDiv.textContent || tempDiv.innerText || "";
    };

    const plainText = getPlainText(content);

    // 2. Agar text limit se chota hai, to direct print kardo (Button nahi chahiye)
    if (plainText.length <= limit) {
        return (
            <p 
                className="person-details"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
            />
        );
    }

    // 3. Render (Toggle Logic)
    return (
        <div className="person-details-wrapper text-center">
            {isExpanded ? (
                // EXPANDED: Asli HTML dikhao formatting ke saath
                <div className="full-content">
                    <p 
                    className="person-details"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
                />

                <button
                className="person-readmore" 
                onClick={() => setIsExpanded(!isExpanded)}
                style={{
                    background: 'none',
                    fontWeight: "normal",
                    border: 'none',
                    cursor: 'pointer',
                    
                    margin: "8px auto"
                }}
            >
                {isExpanded ? 'Read Less' : 'Read More'}
            </button>
                </div>
            ) : (
                // COLLAPSED: Sirf Plain Text dikhao + "..." (Tags remove karke taake design na toote)
                <p className="person-details">
                    {plainText.substring(0, limit)}... <br /><button 
                onClick={() => setIsExpanded(!isExpanded)}
                className="person-readmore"
                style={{
                    background: 'none',
                    fontWeight: "normal",
                    border: 'none',
                    cursor: 'pointer',
                    margin: "8px auto"
                }}
            >
                {isExpanded ? 'Read Less' : 'Read More'}
            </button>
                </p>
            )}

           
        </div>
    );
};

export default ReadMore;